import { uri } from '../../api-endpoint';
import { ITrainingInfoFromAPISuccessResponse } from '../../type-conversion/training/from-api-response';
import { fetchListTemplateFn } from '../common';

export const fetchTrainingListAPI = (token: string) => (modelId: number) =>
  fetchListTemplateFn(
    token,
    uri.modelTrainingList(modelId),
    ITrainingInfoFromAPISuccessResponse
  );
